import React from 'react';
import './Anstroemgeschwindigkeit.css';
import { calculateAnstroemgeschwindigkeit } from '../calculations/airflow';


class Anstroemgeschwindigkeit extends React.Component {
  //Ermittelt die Anströmgeschwindigkeit
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }

  _getAnstroemgeschwindigkeit(){
      //Berechnet die Luftgeschwindigkeit im Kulissenspalt
      let vs = calculateAnstroemgeschwindigkeit({
          Volumenstrom: this.props.Volumenstrom,
          Schalldaempferbreite: this.props.Schalldaempferbreite,
          Schalldaempferhoehe: this.props.Schalldaempferhoehe,
      });
      this.props.AnstroemgeschwindigkeitChange(vs);
      return vs;
  }

  render() {
      return (
        <>{this._getAnstroemgeschwindigkeit().toFixed(2)}
        </>


    );
  }
}
export default Anstroemgeschwindigkeit;
